/* eslint-disable jsx-a11y/anchor-is-valid, jsx-a11y/href-no-hash */
import React from 'react';
import PropTypes from 'prop-types';
import { NavLink } from 'react-router-dom';
import ErrorBoundary from '@blockcatio/tabby-library/lib/components/ErrorBoundary';

import { TERMS_OF_SERVICE_URL, SUPPORT_LINK } from '../constants';

const SiteWrapper = ({
  envName, networkName, children, onError, hasError,
}) => (
  <div id="wrapper">
    <header id="header">
      {envName && (
        <div className="environment-banner">
          <div className="container">
            <span>{envName}</span> on {networkName}
          </div>
        </div>
      )}
      <div className="container main-header">
        <div className="nav-wrapper">
          <div className="top-panel">
            <span className="logo">
              <NavLink href="/" exact to="/" className="brand-logo" id="home-link">
                <img src="/images/blockcat-small.svg" alt="TabbyPay" className="img-responsive" />
              </NavLink>
            </span>
            <ul className="secondary">
              <li>
                <a href={SUPPORT_LINK}>
                  Support
                </a>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </header>
    <main id="main">
      <div className="page-holder">
        <div className="container">
          <ErrorBoundary onError={onError} hasError={hasError}>
            {children}
          </ErrorBoundary>
        </div>
      </div>
    </main>
    <footer className="page-footer" id="footer">
      <div className="footer-copyright">
        <div className="container">
          <div className="row row-md-flex align-center">
            <div className="col m4 s12">
              <span className="copyright-text">
                &copy; {new Date().getFullYear()} <a href="https://blockcat.io">BlockCAT</a>
              </span>
            </div>
            <div className="col m8 s12">
              <ul className="footer-list">
                <li>
                  <a href={TERMS_OF_SERVICE_URL} target="_blank" rel="noopener noreferrer">
                    Terms of Service
                  </a>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </footer>
  </div>
);

SiteWrapper.defaultProps = {
  envName: '',
  networkName: '',
  onError: () => null,
  hasError: false,
};

SiteWrapper.propTypes = {
  envName: PropTypes.string,
  networkName: PropTypes.string,
  children: PropTypes.node.isRequired,
  onError: PropTypes.func,
  hasError: PropTypes.bool,
};

export default SiteWrapper;



// WEBPACK FOOTER //
// ./src/components/SiteWrapper.js